import { render, staticRenderFns } from "./CarRecordNum.vue?vue&type=template&id=309507b0&scoped=true"
import script from "./CarRecordNum.vue?vue&type=script&lang=js"
export * from "./CarRecordNum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309507b0",
  null
  
)

export default component.exports